import { MsalGuardConfiguration, MsalInterceptorConfiguration, MsalService } from "@azure/msal-angular";
import { IPublicClientApplication, PublicClientApplication, BrowserCacheLocation, InteractionType } from "@azure/msal-browser";
import { environment } from "../environments/environment";

export function initilizeMsal(msalService: MsalService): () => Promise<void> {
    return () => {
        return msalService.instance.handleRedirectPromise()
        .then(() => {
            const accounts = msalService.instance.getAllAccounts();
            if(accounts.length > 0) {
                msalService.instance.setActiveAccount(accounts[0]);
            }
        });
    };
}

export function MSALInstanceFactory(): IPublicClientApplication {
  const isIE = window?.navigator?.userAgent?.indexOf('MSIE ') > -1
   || window?.navigator?.userAgent?.indexOf('Trident/') > -1;
  return new PublicClientApplication({
    auth: {
      clientId: environment.appConfig.common.ssipClientId,
      authority: environment.appConfig.common.ssipAuthority,
      redirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE
    }
  });
}

// MSAL Interceptor is required to request access tokens in order to access the protected resource (Graph)
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  // common for dev/test/stage/prod
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);
  protectedResourceMap.set(`${environment.appConfig.common.ssipApiUrl}/logs`, environment.appConfig.common.custtpApiScopes);
  protectedResourceMap.set(`${environment.appConfig.common.ssipApiUrl}/eu/digital/dss/custtp`, environment.appConfig.common.custtpApiScopes)

  // OpCo specific APIs
  protectedResourceMap.set(environment.appConfig.ACE.custtpApiUrl, environment.appConfig.common.custtpApiScopes);
  protectedResourceMap.set(environment.appConfig.BGE.custtpApiUrl, environment.appConfig.common.custtpApiScopes);
  protectedResourceMap.set(environment.appConfig.ComEd.custtpApiUrl, environment.appConfig.common.custtpApiScopes);
  protectedResourceMap.set(environment.appConfig.DPL.custtpApiUrl, environment.appConfig.common.custtpApiScopes);
  protectedResourceMap.set(environment.appConfig.PECO.custtpApiUrl, environment.appConfig.common.custtpApiScopes);
  protectedResourceMap.set(environment.appConfig.PEPCO.custtpApiUrl, environment.appConfig.common.custtpApiScopes);

  return {
    interactionType: InteractionType.Redirect,
    protectedResourceMap
  };
}

// MSAL Guard is required to protect routes and require authentication before accessing protected routes
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: {
      scopes: ['user.read']
    }
  };
}


